<ng-container *ngIf="folder">
    <ng-container *ngIf="parentNames.length">
        <div [matTooltip]="parentsTooltip"
             class="ui-folder-tree-breadcrumbs-path"
             data-cy="folder-path">
            <span *ngFor="let parent of parentNames; let last = last">
                <span class="ui-folder-tree-breadcrumb">
                    {{ parent + ' ' }}
                </span>
                <span *ngIf="!last">/</span>
            </span>
        </div>
    </ng-container>

    <div class="ui-folder-tree-breadcrumbs-current-folder">
        <mat-icon *ngIf="showFolderIcon"
                  [matTooltip]="'FolderType_' + folder!.type | translate"
                  [class.ui-folder-icon-modern]="folder!.type === FolderType.Modern"
                  [class.ui-folder-icon-classic]="folder!.type === FolderType.Classic">
            folder_open
        </mat-icon>

        <span data-cy="folder-name">
            {{folder!.displayName}}
        </span>
    </div>
</ng-container>
